import moduleBuilder from '@/store/module-builder';
import store from '@/store/store';

export interface Snack {
  message: string;
  level: 'info' | 'warn' | 'error';
  sticky: boolean;
}

export function notify(message: string, level: Snack['level'] = 'info', sticky = false) {
  notification.dispatch.snack({ message, level, sticky });
}
export function notifyError(message: string) {
  notify(message, 'error', true);
}

const notification = moduleBuilder()
  .state({
    snack: undefined as Snack | undefined,
  })
  .mutations({
    setSnackMessage(state, s: Snack) {
      // eslint-disable-next-line no-console
      console.log(`Notification: ${s.message}`);
      state.snack = s;
    },
  })
  .actions({
    snack(ctx, s: Snack) {
      // TODO: implement message queue
      ctx.commit('setSnackMessage', s);
    },
  })
  .hideMutations()
  .register(store, 'notification');

export default notification;
